import React from "react";
import "./not-found.m.css";

const NotFoundPage = () => {
  return (
    <div styleName="video-container-wrapper">
      <div styleName="top-banner-static-image">
        <div styleName="custom-hero-heading">
          <h1>Oho!<br />Sivua ei löytynyt</h1>
          <img styleName="logoImage" src="/icons/radio_dei_plus.svg" width="100" height="100" alt="Radio Dei Plus" />
        </div>
        <img src="/assets/404-hero.jpeg" styleName="big-desktop-image" alt="Desktop Hero" />
        <img src="/assets/404-mobile-hero.jpeg" styleName="portrait-mobile-image" alt="Mobile Hero" />
      </div>
      <div styleName="midContentWrapper">
        <div styleName="plans-static-text">
          <h2 styleName="notFoundTitle">Tervetuloa uudistuneeseen Dei Plus -palveluun!</h2>
          <p>Löydät jatkossa täältä kaikki Radio Dein ja Dei Plussan sisällöt ja palvelut. Tarjoamme jatkuvasti uudistuvaa ja laadukasta<br /> sisältöä: podcast- ja videosarjoja sekä kaikki Radio Dein radiokanavat - kuunneltavissa ja katsottavissa missä ja milloin <br />tahansa.</p>
        </div>

        <div styleName="plans-static-text">
          <p>Voit siirtyä uudistuneeseen palveluun alla olevien painikkeiden avulla tai valita sen yläreunan valikosta.</p>
        </div>
      </div>
      <div styleName="not-found-buttons">
        <a styleName="pricing-button" href="/">
          Etusivulle
        </a>
        <a styleName="pricing-button" href="/radiot">
          Radiokanavat
        </a>
      </div>
    </div>
  );
};

export { NotFoundPage };
